import React, { forwardRef, useState } from 'react';

import countries from '../../../../utils/COUNTRIESLIST';
import { toast } from 'react-toastify';

const ContactForm =forwardRef( (props,ref) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    company: '',
    country: '',
    message: '',
    marketing: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ show: false, success: false, message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('https://api.kapiltech.com/api/infor/InforContactForm ', { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      if (data.success) {
        toast.success('We will get back to you soon!');
        resetForm();
      } else {
        toast.error(data.message || 'Something went wrong. Please try again.');
      }
      
    } catch (error) {
      console.error('Error in form submission:', error);
      toast.error('Something went wrong. Please try again.');
      
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const resetForm = () => {
    setFormData({
      name: '',
      phone: '',
      email: '',
      company: '',
      country: '',
      message: '',
      marketing: false
    });
  };
 const COLORS = {
    headingGradientStart: "#6b46c1", // Deep purple
    headingGradientEnd: "#8a5cf6",   // Medium purple
    headingAccent: "#c4b5fd",        // Light purple
    background: "#f8f7ff",           // Very light purple background
    shadow: "rgba(107, 70, 193, 0.2)" // Purple shadow with opacity
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8" ref={ref} >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-10">
          {/* Left side - Image and Heading */}
       
    <div className="w-full md:w-1/2 flex flex-col items-center md:items-start p-8 rounded-xl" style={{ backgroundColor: COLORS.background }}>
      <div className="relative mb-8">
        {/* Decorative elements */}
        <div className="absolute -top-4 -left-6 w-16 h-16 rounded-full" style={{ 
          background: `linear-gradient(135deg, ${COLORS.headingAccent} 0%, transparent 70%)`,
          opacity: 0.6
        }}></div>
        
        <div className="absolute -bottom-2 -right-4 w-24 h-12 rounded-full" style={{ 
          background: `linear-gradient(45deg, ${COLORS.headingAccent} 0%, transparent 70%)`,
          opacity: 0.4
        }}></div>
        
        {/* Main heading with gradient */}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold relative z-10 leading-tight">
          <span className="block text-3xl md:text-4xl lg:text-4xl" style={{ 
            background: `linear-gradient(to right, ${COLORS.headingGradientStart}, ${COLORS.headingGradientEnd})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textShadow: `0 4px 12px ${COLORS.shadow}`
          }}>
            We are excited
          </span>
          <span className="block text-1xl md:text-2xl lg:text-3xl" style={{ 
            background: `linear-gradient(to right, ${COLORS.headingGradientEnd}, ${COLORS.headingGradientStart})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textShadow: `0 4px 12px ${COLORS.shadow}`
          }}>
            to hear about it!
          </span>
        </h1>
      </div>
      
      <div className="relative w-full max-w-md mx-auto md:mx-0 transition-all duration-300 transform hover:scale-102">
        {/* Drop shadow behind image */}
        <div className="absolute inset-0 rounded-2xl" style={{ 
          boxShadow: `0 20px 25px -5px ${COLORS.shadow}, 0 10px 10px -5px ${COLORS.shadow}`,
          transform: "translateY(8px) scale(0.95)",
          filter: "blur(8px)",
          zIndex: 0
        }}></div>
        
        {/* Decorative border */}
        <div className="absolute -inset-1 rounded-2xl" style={{
          background: `linear-gradient(45deg, ${COLORS.headingGradientStart}40, ${COLORS.headingGradientEnd}40)`,
          zIndex: 1
        }}></div>
        
        {/* Image */}
        <img 
          src="https://ik.imagekit.io/kqumni8l2/SAP/13.png?updatedAt=1754031260225" 
          alt="Email illustration" 
          className="w-full relative z-10 rounded-xl"
          style={{ border: `4px solid white` }}
        />
        
        {/* Floating decorative elements */}
        <div className="absolute -top-6 -right-6 w-12 h-12 rounded-full bg-white shadow-lg z-20 flex items-center justify-center">
          <div className="w-8 h-8 rounded-full" style={{ background: COLORS.headingGradientEnd }}></div>
        </div>
        <div className="absolute -bottom-4 -left-4 w-10 h-10 rounded-full bg-white shadow-lg z-20 flex items-center justify-center">
          <div className="w-6 h-6 rounded-full" style={{ background: COLORS.headingGradientStart }}></div>
        </div>
      </div>
    </div>
  


          {/* Right side - Form */}
          <div className="w-full md:w-1/2">
            <div className="w-full space-y-6">
              {/* Name Field */}
              <div>
                <input
                  type="text"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full border-b border-gray-300 py-3 px-2 focus:outline-none focus:border-[#FF7A41] transition-colors"
                  placeholder="Name"
                />
              </div>

              {/* Email Field */}
              <div>
                <input
                  type="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full border-b border-gray-300 py-3 px-2 focus:outline-none focus:border-[#FF7A41] transition-colors"
                  placeholder="Email"
                />
              </div>
              
              {/* Phone Field */}
              <div>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full border-b border-gray-300 py-3 px-2 focus:outline-none focus:border-[#FF7A41] transition-colors"
                  placeholder="Phone Number"
                />
              </div>
              
              {/* Company Field */}
              <div>
                <input
                  type="text"
                  name="company"
                  required
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full border-b border-gray-300 py-3 px-2 focus:outline-none focus:border-[#FF7A41] transition-colors"
                  placeholder="Company"
                />
              </div>
              
              {/* Country Field */}
              <div>
                <select
                  name="country"
                  required
                  value={formData.country}
                  onChange={handleChange}
                  className="w-full border-b border-gray-300 py-3 px-2 focus:outline-none focus:border-[#FF7A41] transition-colors bg-white appearance-none"
                >
                  <option value="">Select your country</option>
                  {countries?.map(country => (
                    <option key={country.code} value={country.code}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Enquirey/ Message Field */}
              <div>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  className="w-full border-b border-gray-300 py-3 px-2 focus:outline-none focus:border-[#FF7A41] transition-colors"
                  placeholder="Enquiry"
                />
              </div>

              {/* Policy Checkbox */}
              <div>
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="marketing"
                    checked={formData.marketing}
                    onChange={handleChange}
                    className="rounded border-gray-300 text-[#FF7A41] focus:ring-[#FF7A41] w-6 h-6"
                  />
                  <span className="text-sm text-gray-600">
                    I agree to the KCS Tech <span className="text-[#FF7A41]">Cookie Policy</span> and <span className="text-[#FF7A41]">Privacy Policy</span>
                  </span>
                </label>
              </div>

              {/* Submit Button and Contact Info */}
              <div className="mt-12 flex flex-col md:flex-row justify-between items-start md:items-center">
                <button
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                  className="bg-[#333333] text-white rounded-md py-4 px-10 font-medium transition-colors hover:bg-[#444444] focus:outline-none focus:ring-2 focus:ring-[#333333] disabled:opacity-70"
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
                
                <div className="mt-6 md:mt-0 text-gray-500">
                  <p className="mb-2">info@kcs-tech.com</p>
                  <p>+91 8889992186</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ContactForm;